import React, { cloneElement, Children, Component } from 'react';
import isFunction from '@insight/toolkit-utils/lib/types/basic/isFunction';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { ACCORDION_VIEW_DEFAULTS, ACCORDION_VIEW_TYPES } from './constants';
import { withAccordion } from './context';
import { checkIfValidChild } from './helpers';
import { Item } from './Item';

export class AccordionView extends Component {
  static propTypes = ACCORDION_VIEW_TYPES;
  static defaultProps = ACCORDION_VIEW_DEFAULTS;

  componentDidMount() {
    const { accordion, contextRef } = this.props;
    if (contextRef) {
      contextRef(accordion);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(this.props.accordion.expanded) !==
      JSON.stringify(prevProps.accordion.expanded)
    ) {
      if (this.props.contextRef) {
        this.props.contextRef(this.props.accordion);
      }
    }
  }

  getContent = () => {
    const {
      accordion,
      allowMultiple,
      autoScroll,
      children,
      items,
      render,
      theme,
    } = this.props;
    if (items.length > 0) {
      return items.map((item) => {
        return (
          <Item
            accordion={accordion}
            autoScroll={autoScroll}
            allowMultiple={allowMultiple}
            key={item.id}
            theme={theme}
            {...item}
          />
        );
      });
    }

    const renderProps = {
      allowMultiple,
      getItemProps: this.getItemProps,
      ...this.getContextProps(),
    };

    if (isFunction(children)) {
      return children(renderProps);
    }
    if (isFunction(render)) {
      return render(renderProps);
    }

    if (children) {
      return Children.map(children, (child) => {
        checkIfValidChild(child);
        return cloneElement(child, {
          accordion,
        });
      });
    }

    return null;
  };

  getContextProps = () => ({
    collapseAll: this.props.accordion.collapseAll,
    expandAll: this.props.accordion.expandAll,
  });

  getItemProps = () => ({
    accordion: this.props.accordion,
  });

  render() {
    const {
      accordion,
      allowMultiple,
      autoScroll,
      children,
      className,
      contextRef,
      items,
      render,
      theme,
      ...rest
    } = this.props;

    const classes = cn(
      'c-accordion',
      theme == 'dark' ? 'c-accordion--dark' : '',
      className
    );

    return (
      <div className={classes} {...rest}>
        {this.getContent()}
      </div>
    );
  }
}

export default withAccordion(AccordionView);
